export const convertTimeslotDateToObject = (schedules) => {
  return schedules.reduce((acc, item) => {
    const date = item.date;

    if (!acc[date]) acc[date] = [];

    acc[date].push({
      id: item.id,
      start: item.start,
      end: item.end,
      availableSlots: item.slots,
    });

    return acc;
  }, {});
};
